export const ADD_NEW_IMPORT = 'ADD_NEW_IMPORT';
export const LOAD_IMPORTS = 'LOAD_IMPORTS';
export const SET_IMPORT_FILTER = 'SET_IMPORT_FILTER';
export const SET_IMPORT_PAGINATION = 'SET_IMPORT_PAGINATION';
export const SET_IMPORT_SORT = 'SET_IMPORT_SORT';
export const RESET_IMPORT_FILTERS = 'RESET_IMPORT_FILTERS';
